"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTooltipRegistration = exports.targetClassName = exports.OnboardingTooltip = exports.OnboardingProvider = exports.OnboardingContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));

var _ArrowForwardIos = _interopRequireDefault(require("@material-ui/icons/ArrowForwardIos"));

var _lazy = require("@jobmatchme/library-utils/es/lazy");

var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _reactI18next = require("react-i18next");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["target", "content", "position"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Joyride = (0, _lazy.lazyLoader)(function () {
  return import(
  /* webpackChunkName: 'Joyride' */
  'react-joyride');
});

var targetClassName = function targetClassName(selector) {
  return "onboarding-tooltip--".concat(selector);
};

exports.targetClassName = targetClassName;

var targetPattern = function targetPattern(selector) {
  return ".".concat(targetClassName(selector));
};

var OnboardingContext = /*#__PURE__*/_react.default.createContext({
  registerStep: function registerStep(step) {},
  unregisterStep: function unregisterStep(step) {},
  runOnboarding: function runOnboarding() {},
  resetOnboarding: function resetOnboarding() {},
  getFunnelTarget: function getFunnelTarget() {
    return undefined;
  },
  showHelpTopic: function showHelpTopic(step) {}
});

exports.OnboardingContext = OnboardingContext;

var OnboardingProvider = function OnboardingProvider(_ref) {
  var children = _ref.children,
      showHelpToggle = _ref.showHelpToggle,
      funnelTarget = _ref.funnelTarget;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      steps = _useState2[0],
      setSteps = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      run = _useState4[0],
      setRun = _useState4[1];

  var joyrideRef = (0, _react.useRef)({});
  var getFunnelTarget = (0, _react.useCallback)(function () {
    return funnelTarget;
  }, [funnelTarget]);
  var showHelpTopic = (0, _react.useCallback)(function (step) {
    setSteps(function (steps) {
      return [].concat((0, _toConsumableArray2.default)(steps.filter(function (step) {
        return step.target === targetPattern(step.target);
      })), [{
        target: targetPattern(step.target),
        content: step.content,
        position: step.position,
        placement: step.placement,
        isFixed: step.isFixed,
        disableBeacon: true,
        offset: step.offset
      }]).sort(function (a, b) {
        return a.position - b.position;
      });
    });
    setRun(true);
  }, []);
  var registerStep = (0, _react.useCallback)(function (_ref2) {
    var target = _ref2.target,
        content = _ref2.content,
        position = _ref2.position,
        rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    setSteps(function (steps) {
      return [].concat((0, _toConsumableArray2.default)(steps.filter(function (step) {
        return step.target !== targetPattern(target);
      })), [(0, _extends2.default)({
        target: targetPattern(target),
        content: content,
        disableBeacon: true,
        position: position
      }, rest)]).sort(function (a, b) {
        return a.position - b.position;
      });
    });
  }, []);
  var unregisterStep = (0, _react.useCallback)(function (_ref3) {
    var target = _ref3.target;
    return setSteps(function (steps) {
      return (0, _toConsumableArray2.default)(steps.filter(function (step) {
        return step.target !== targetPattern(target);
      }));
    });
  }, []);
  var value = (0, _react.useMemo)(function () {
    return {
      registerStep: registerStep,
      unregisterStep: unregisterStep,
      getFunnelTarget: getFunnelTarget,
      runOnboarding: function runOnboarding() {
        return setRun(true);
      },
      resetOnboarding: function resetOnboarding() {
        return setRun(false);
      },
      showHelpTopic: showHelpTopic
    };
  }, [registerStep, unregisterStep, getFunnelTarget, showHelpTopic]);

  var callback = function callback(state) {
    if (state.status === 'finished') {
      setRun(false);
    } else if (state.action === 'close') {
      var _joyrideRef$current, _joyrideRef$current$s;

      setRun(false);
      (_joyrideRef$current = joyrideRef.current) === null || _joyrideRef$current === void 0 ? void 0 : (_joyrideRef$current$s = _joyrideRef$current.store) === null || _joyrideRef$current$s === void 0 ? void 0 : _joyrideRef$current$s.reset();
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(OnboardingContext.Provider, {
    value: value,
    children: [steps.length > 0 && showHelpToggle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Slide.default, {
      direction: "left",
      in: !run,
      mountOnEnter: true,
      unmountOnExit: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _styleModule.default.helpButtonWrapper,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
          color: "dark",
          variant: "outlined",
          round: true,
          flat: true,
          texttransform: "none",
          onClick: function onClick() {
            return setRun(true);
          },
          className: _styleModule.default.helpButton,
          size: "small",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_HelpOutline.default, {}), " Hilfe"]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.default.Suspense, {
      fallback: "",
      children: run && /*#__PURE__*/(0, _jsxRuntime.jsx)(Joyride, {
        ref: joyrideRef,
        callback: callback,
        steps: steps,
        run: run,
        continuous: true,
        disableScrolling: true,
        spotlightClicks: true,
        tooltipComponent: Tooltip,
        floaterProps: {
          disableAnimation: true,
          styles: {
            wrapper: {
              zIndex: 1000
            }
          }
        },
        styles: {
          options: {
            zIndex: 1000,
            primaryColor: '#e50076',
            maxWidth: '322px'
          },
          spotlight: {
            // Set your border-radius here!
            borderRadius: '14px',
            marginTop: '5px'
          }
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: run ? {
        overflow: 'hidden',
        height: '100vh'
      } : {},
      children: children
    })]
  });
};

exports.OnboardingProvider = OnboardingProvider;

var useTooltipRegistration = function useTooltipRegistration(step) {
  var bypass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var context = (0, _react.useContext)(OnboardingContext);
  var registerStep = context.registerStep,
      unregisterStep = context.unregisterStep;
  (0, _react.useEffect)(function () {
    if (!bypass) {
      registerStep(step);
      return function () {
        return unregisterStep(step);
      };
    }
  }, [step, bypass, registerStep, unregisterStep]);
  return context;
};

exports.useTooltipRegistration = useTooltipRegistration;

var OnboardingTooltip = function OnboardingTooltip(_ref4) {
  var step = _ref4.step,
      children = _ref4.children;
  useTooltipRegistration(step);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: targetClassName(step.target),
    children: children
  });
};

exports.OnboardingTooltip = OnboardingTooltip;

var Tooltip = function Tooltip(_ref5) {
  var index = _ref5.index,
      step = _ref5.step,
      backProps = _ref5.backProps,
      closeProps = _ref5.closeProps,
      primaryProps = _ref5.primaryProps,
      tooltipProps = _ref5.tooltipProps,
      size = _ref5.size;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var componentNs = "ui:ui.Onboarding";
  var width = 290;

  if (window.innerWidth > 480) {
    width = 380;
  } else {
    width = 270;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Paper.default, (0, _extends2.default)({
    elevation: 1
  }, tooltipProps, {
    className: _styleModule.default.tooltip,
    style: {
      width: "".concat(width, "px")
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, (0, _extends2.default)({
      "aria-label": "Close",
      className: _styleModule.default.closeButton
    }, closeProps, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close.default, {})
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.content,
      children: step.content
    }), size > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      spacing: 0,
      className: "".concat(_styleModule.default.border, " ").concat(_styleModule.default.buttons),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 5,
        className: "".concat(_styleModule.default.gridItem, " ").concat(_styleModule.default.alignLeft),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, (0, _extends2.default)({
          variant: "text",
          round: true,
          flat: true,
          text: true,
          extraBold: true,
          texttransform: "none",
          disabled: index === 0
        }, backProps, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
            className: _styleModule.default.bold,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowBackIos.default, {
              fontSize: "small"
            }), t("".concat(componentNs, ".back"))]
          })
        }))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 2,
        className: _styleModule.default.gridItem,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          component: "span",
          className: _styleModule.default.counter,
          children: "".concat(index + 1, "  ").concat(t("".concat(componentNs, ".from")), " ").concat(size)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 5,
        className: "".concat(_styleModule.default.gridItem, " ").concat(_styleModule.default.alignRight),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, (0, _extends2.default)({
          variant: "text",
          round: true,
          flat: true,
          text: true,
          extraBold: true,
          texttransform: "none"
        }, primaryProps, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
            className: _styleModule.default.bold,
            children: [t(index + 1 === size ? "".concat(componentNs, ".done") : "".concat(componentNs, ".next")), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowForwardIos.default, {
              fontSize: "small"
            })]
          })
        }))
      })]
    })]
  }));
};